import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FooterMessages, FooterText } from './Footer.messages';
import { LocaleSelector } from '../../navigation/LocaleSelector';
import { CommonMessages } from '../../i18n/Common.messages';
import { Logo } from '../common/Logo';
import { BUILD_YEAR } from '../../buildInfo';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  // Build-time constant, not `new Date()`: this page is prerendered and hydrated,
  // and a clock-derived year would mismatch the snapshot every New Year.
  const currentYear = BUILD_YEAR;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="footer-logo">
                <Logo size={32} />
                <span className="brand-name">{t(CommonMessages.APP_NAME)}</span>
              </div>
              <p className="footer-tagline">{t(FooterMessages.TAGLINE)}</p>
            </div>

            <div className="footer-links">
              <div className="footer-section">
                <h4 className="footer-section-title">{t(FooterMessages.SECTION_PRODUCT)}</h4>
                <ul className="footer-link-list">
                  <li><Link to="/pricing" className="footer-link">{t(FooterMessages.LINK_PRICING)}</Link></li>
                  <li><Link to="/use-cases" className="footer-link">{t(FooterMessages.LINK_USE_CASES)}</Link></li>
                  <li><Link to="/get-started" className="footer-link">{t(FooterMessages.LINK_GET_STARTED)}</Link></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-section-title">{t(FooterMessages.SECTION_DEVELOPERS)}</h4>
                <ul className="footer-link-list">
                  <li><Link to="/docs" className="footer-link">{t(FooterMessages.LINK_DOCUMENTATION)}</Link></li>
                  <li><Link to="/blog" className="footer-link">{t(FooterMessages.LINK_BLOG, { defaultValue: FooterText.LINK_BLOG })}</Link></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-section-title">{t(FooterMessages.SECTION_SUPPORT)}</h4>
                <ul className="footer-link-list">
                  <li><Link to="/contact" className="footer-link">{t(FooterMessages.LINK_CONTACT)}</Link></li>
                  <li><Link to="/status" className="footer-link">{t(FooterMessages.LINK_STATUS)}</Link></li>
                </ul>
              </div>

              <div className="footer-section">
                <h4 className="footer-section-title">{t(FooterMessages.SECTION_COMPANY)}</h4>
                <ul className="footer-link-list">
                  <li><Link to="/about" className="footer-link">{t(FooterMessages.LINK_ABOUT)}</Link></li>
                  <li><Link to="/security" className="footer-link">{t(FooterMessages.LINK_SECURITY)}</Link></li>
                  <li><Link to="/privacy" className="footer-link">{t(FooterMessages.LINK_PRIVACY)}</Link></li>
                  <li><Link to="/terms" className="footer-link">{t(FooterMessages.LINK_TERMS)}</Link></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <LocaleSelector dropUp />
                <p className="copyright" style={{ margin: 0 }}>
                  {t(FooterMessages.COPYRIGHT, { year: currentYear })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
